<template>
  <div>
    Loading...
    <br />
    <div v-if="wobble">
    <amenity-manatee-wobble></amenity-manatee-wobble>
    </div>
    <div v-else>
    <amenity-manatee-crank></amenity-manatee-crank>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  mounted() {
this.randomManatee();
  },

  methods: {
    randomManatee() {
      var manatee = Math.floor(Math.random() * 100);
      if (manatee === 0) {
        this.wobble = false;
      } else {
        this.wobble = true;
      }
    },
  },
  computed: {},
  data() {
    return {
       wobble: true,
    };
  },
};
</script>
